(function() {
  'use strict';
  
  function initSearch() {
    // Toggle search modal
    const searchToggler = document.querySelectorAll('.search-opener');
    const searchModal = document.querySelector('.search-modal');
    const closeBtn = document.querySelector('.close-search');
    const clearBtn = document.querySelector('.search-bar .clear');
    const searchInput = document.getElementById('mobileSearchQuery');
    const productContainer = document.getElementById('product-container');

    console.log('Search init:', {
      togglerCount: searchToggler.length,
      hasModal: !!searchModal,
      hasInput: !!searchInput
    });

    function openModal() {
      if (searchModal) {
        searchModal.classList.add('opened');
        document.body.classList.add('modal-open');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
        console.log('Search modal opened');
      }
    }
    
    function closeModal() {
      if (searchModal) {
        searchModal.classList.remove('opened');
        document.body.classList.remove('modal-open');
        if (productContainer) productContainer.innerHTML = "";
        if (searchInput) searchInput.value = "";
        if (clearBtn) clearBtn.style.display = 'none';
        console.log('Search modal closed');
      }
    }

    if (searchToggler.length > 0) {
      searchToggler.forEach(single => {
        single.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Search opener clicked');
          openModal();
          return false;
        }, false);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    }

    // Dismiss modal on escape
    document.addEventListener('keydown', function(e){
      if (e.key === "Escape" && searchModal && searchModal.classList.contains('opened')) {
        closeModal();
      }
    });

    // Close modal when clicking on the overlay (backdrop)
    if (searchModal) {
      searchModal.addEventListener('click', function(e) {
        // Only close if clicking directly on the modal (the overlay), not its children
        if (e.target === searchModal || e.target.classList.contains('search-modal')) {
          closeModal();
        }
      });
    }

    // Handle search
    let debounceTimeout;
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = searchInput.value.trim();
        if (clearBtn) clearBtn.style.display = query ? 'inline-block' : 'none';

        clearTimeout(debounceTimeout);
        if (!query) {
          if (productContainer) productContainer.innerHTML = "";
          return;
        }
        
        debounceTimeout = setTimeout(() => {
          // Show loading state
          if (productContainer) {
            productContainer.innerHTML = '<div style="color: #666; padding: 1rem; text-align: center;">Searching...</div>';
          }
          
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
            .then(res => res.json())
            .then(data => {
              if (productContainer) {
                if (data.resources && data.resources.results && data.resources.results.products) {
                  const products = data.resources.results.products;
                  
                  if (products.length === 0) {
                    productContainer.innerHTML = '<div style="color: #666; padding: 1rem; text-align: center;">No products found</div>';
                    return;
                  }
                  
                  productContainer.innerHTML = products.map(product => {
                    const price = product.price ? `${(product.price / 100).toFixed(2)}` : '';
                    const imageSrc = product.image || product.featured_image || '';
                    
                    return `
                      <div class="product-card">
                        <a href="${product.url}" style="display: flex; align-items: center; gap: 0.8rem; text-decoration: none; width: 100%;">
                          ${imageSrc ? `<img src="${imageSrc}" alt="${product.title}" loading="lazy">` : '<div style="width: 80px; height: 80px; background: #f5f5f5; border-radius: 6px; border: 1px solid #e0e0e0;"></div>'}
                          <div class="product-info">
                            <h3 class="product-title">${product.title}</h3>
                            ${price ? `<p class="product-price">AED ${price}</p>` : ''}
                          </div>
                        </a>
                      </div>
                    `;
                  }).join('');
                } else {
                  productContainer.innerHTML = '<div style="color: #666; padding: 1rem; text-align: center;">No results found</div>';
                }
              }
            })
            .catch(err => {
              console.error('Search error:', err);
              if (productContainer) {
                productContainer.innerHTML = '<div style="color: #dc143c; padding: 1rem; text-align: center;">Search error. Please try again.</div>';
              }
            });
        }, 300);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (searchInput) searchInput.value = "";
        if (productContainer) productContainer.innerHTML = "";
        clearBtn.style.display = 'none';
        if (searchInput) searchInput.focus();
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }
})();
